import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projects-details-immo',
  templateUrl: './projects-details-immo.component.html',
  styleUrls: ['./projects-details-immo.component.scss']
})
export class ProjectsDetailsImmoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
